/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  loadRentReport.js
 */

import { BetaFeature, ON_BROWSER, isBetaFeatureEnabled } from '@zcode/nr-utils'
import { deleteHash } from '@zcode/nr/es/shared/packages/history-middleware'
import { MODAL_TYPE } from '@zcode/state-type'
import type { RouteComponentProps } from 'react-router'
import type { Dispatch } from 'redux'
import { isRentReportCityState } from '../../../../components/HashtagModal/editorials/rentReports'
import { selectCurrentSearchUrl } from '../../../currentSearch/selectors/index'
import { selectHash } from '../../../router/selectors/index'
import type { GetState } from '../../../types'
import { setCityState, setHashtagType, setRentReport } from '../../actions/hashtagModal'
import { closeModal, openModal } from '../../actions/index'
import { HASHTAG_TYPES, isAllowedHashtag } from '../../constants/hashtagModal'
import { selectOpenModal } from '../../selectors'
import { loadMetroRentReport } from './loadMetroRentReport'
import { loadRentReport } from './loadRentReport'

// Ideally, we would be grabbing the data to populate the modal from an API.
// For now, we're going to just be setting the hash type and city state so we can
// grab the correct source for an iframe
export const loadHashtagContent =
  (routeProps: Pick<RouteComponentProps, 'location'>) =>
  async (dispatch: Dispatch, getState: GetState) => {
    if (ON_BROWSER) {
      const url = selectCurrentSearchUrl(getState())
      const hash = selectHash(routeProps)?.substring?.(1)
      const openedModal = selectOpenModal(getState())

      if (isAllowedHashtag(hash)) {
        if (hash === HASHTAG_TYPES.RENT_REPORT && url && isRentReportCityState(url)) {
          dispatch(loadMetroRentReport())
          dispatch(setHashtagType(hash))
          dispatch(setRentReport(null))
          dispatch(setCityState(null))
          dispatch(openModal(MODAL_TYPE.HASHTAG))
        } else if (url && isRentReportCityState(url)) {
          // we have the html for the requested citystate/type
          dispatch(setCityState(url))
          dispatch(setHashtagType(hash))
          dispatch(setRentReport(null))
          dispatch(openModal(MODAL_TYPE.HASHTAG))
        } else if (routeProps.location.pathname === '/') {
          // homepage -- national rent report
          dispatch(setCityState(null))
          dispatch(setHashtagType(hash))
          dispatch(loadRentReport())
          dispatch(openModal(MODAL_TYPE.HASHTAG))
        } else {
          // remove hash from url since we don't have anything to show
          dispatch(deleteHash())
        }
      } else if (!hash) {
        dispatch(setHashtagType(null))
        if (openedModal === MODAL_TYPE.HASHTAG) {
          dispatch(closeModal())
        }
      }
    }
  }
